/**
 * Escapes characters like '[]' used for accessing json objects inside a formula
 */
export function escapeAttrName(attrName: string): string {
  return attrName.replace(/(\[)/g, '\\$1').replace(/(])/g, '\\$1');
}
